/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_Account_DetailsInputs */

const en_users_detail_account_details = /** @type {(inputs: Users_Detail_Account_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Details`)
};

const pt_br2_users_detail_account_details = /** @type {(inputs: Users_Detail_Account_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados da Conta`)
};

/**
* | output |
* | --- |
* | "Account Details" |
*
* @param {Users_Detail_Account_DetailsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_account_details = /** @type {((inputs?: Users_Detail_Account_DetailsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Account_DetailsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_account_details(inputs)
	return pt_br2_users_detail_account_details(inputs)
});